import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { Header } from 'src/components/Header';
import { SplashScreen } from 'src/components/SplashScreen/SplashScreen';
import { RoutesLayout } from 'src/containers/RoutesLayout/RoutesLayout';
import { useUrlUiSettings } from 'src/hooks/useUrlUiSettings';
import { AppStore } from 'src/stores/AppStore/AppStore';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { CssVariables } from 'src/styles/CssVariables';
import styled from 'styled-components';

export const AppLayout = observer(() => {
    useUrlUiSettings();

    if (!AuthStore.authenticated || !AppStore.started) {
        return <SplashScreen />;
    }

    return (
        <Layout>
            <Header />
            <StyledContent>
                <RoutesLayout />
            </StyledContent>
        </Layout>
    );
});

const StyledContent = styled(Layout.Content)`
    background-color: var(--background);
    margin-top: ${CssVariables.headerHeight};
    height: calc(100vh - ${CssVariables.headerHeight});
    overflow: auto;
`;
